import { Component, OnInit, Input } from '@angular/core';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { CommonService } from 'src/app/Service/Common.service';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { IMsgElementInputModel, IMsgHistoryInputModel } from 'src/app/ViewModel/CommunicationModel';
import { ReplyMessageComponent } from '../reply-message/reply-message.component';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { MailHistoryLogComponent } from '../mail-history-log/mail-history-log.component';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { FileUploadLibrary } from 'src/app/Service/file/file.service';

@Component({
  selector: 'app-mail-view',
  templateUrl: './mail-view.component.html',
  styleUrls: ['./mail-view.component.css']
})
export class MailViewComponent implements OnInit {

  private _viewData: any[] = [];
  @Input() set viewData(value: any) {
    if (!!value && typeof value == "object") {
      this._viewData = value;
      let docData = this.viewData[0];
      if (!!docData) {
        this.messageId = docData.messageId;
        this.getMessage();
        this.getMessageElements(this.messageId);
      }
    }
  }
  get viewData(): any {
    return this._viewData;
  }

  public messageElements: any;
  public isexpanded = true;
  isallExpand = true;
  message: any;
  mailType!: string;
  messageId!: number;
  projectId: number = 0;
  groupId: number = 0;
  memberId: number = 0;
  roleId: number = 0;
  attachments: any[] = [];
  documents: any[] = [];
  public messageHistoryDetails: any[] = [];
  from: any[] = [];
  sentOn!: string | null;
  messageSubject: string = "";
  projectName!: string | null;
  receivers: any[] = [];
  to: string = '';
  cc: string = '';
  fromOrg: string = '';
  toOrg: string = '';
  canReply: boolean = false;

  constructor(
    public communicationService: CommunicationService,
    public commonService: CommonService,
    private encryptDecryptService: EncryptDecryptService,
    public datepipe: DatePipe,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.commonService.getProjectMemberRoles(this.projectId, this.groupId, this.memberId).subscribe((result: any[]) => {
      this.roleId = +result;
    });
    this.callMemberRoleandFeature();
  }

  callMemberRoleandFeature() {
    this.commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((result1: any[]) => {
      this.canReply = result1.some(data => data.feature_Desc == 'Reply');
    });
  }

  getProjectName() {
    var project = JSON.parse(this.commonService.getSessionStorageItem('projectObject'));
    this.projectName = this.commonService.getProjectCode() + ' - ' + project.projectDescription;
  }

  async getMessage() {

    let data = await this.communicationService.getMessageDetails(this.messageId).toPromise();
    this.message = data[0];

    let result = this.message.from;
    this.from = result.split("-");
    this.messageId = this.message.messageId;
    this.getMessageElements(this.messageId);
    this.getReceivers(this.message.messageId);
    this.mailType = data[0].messageTypeShortDesc;
    this.sentOn = this.datepipe.transform(this.message.createdOn, 'dd-MMM-yyyy HH:mm:ss');
    this.messageSubject = this.message.messageSubject;
  }
  async getReceivers(messageId: number) {
    this.receivers = await this.communicationService.GetMessageReceiverList(messageId).toPromise();
    this.to = this.receivers.filter(x => x.receiverType == 2).map(x => x.memberName).toString();
    this.cc = this.receivers.filter(x => x.receiverType == 3).map(x => x.memberName).toString();
  }
  async getMessageElements(messageId: number) {
    if (messageId > 0) {
      let inputModel: IMsgHistoryInputModel = {
        projectId: this.projectId,
        groupId: this.groupId,
        messageId: this.messageId,
        memberId: this.memberId,
        roleId: this.roleId
      };
      this.messageElements = await this.communicationService.getMessageElementsById(messageId).toPromise();
      this.fromOrg = this.messageElements.filter((x: { deDescription: string; }) => x.deDescription == 'From Org').map((x: { dedDescription: any; }) => x.dedDescription).toString();
      this.toOrg = this.messageElements.filter((x: { deDescription: string; }) => x.deDescription == 'To Org').map((x: { dedDescription: any; }) => x.dedDescription).toString();

    }
  }

  respondMail(inputType: string) {

    const dialogRef = this.dialog.open(ReplyMessageComponent, {
      panelClass: 'mat-dialog-primary',
      disableClose: true,
      data: { inputType: inputType, selectedMessageId: this.messageId }
    });
  }

  viewHistoryLog() {
    this.dialog.open(MailHistoryLogComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '53%',
      data: { messageId: this.messageId },
    });
  }

  viewAttachmentClick() {
    this.dialog.open(FileListComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '60%',
      data: { messageId: this.messageId, projectId: this.projectId, libraryName: FileUploadLibrary.Communication, documentNo: "" }
    })
  }
}
